import { Box, colors, DialogActions, DialogContent, DialogContentText, Input, styled, SxProps, Typography, useMediaQuery, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import { Component } from "react";
import TextConfirmButton from "../../AppButtons/TextConfirmButton";
import ScrollTop from "../../ScrollTop/ScrollTop";

export const InputQauntity = styled(Input, { label: "DrawerPartDetails-InputQuantity" })(
    ({ theme }) => ({
        // Per nascondere le frecce su Webkit (Chrome, Safari, Edge)
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0,
        },
        // Per nascondere le frecce su Firefox
        "& input[type=number]": {
            MozAppearance: "textfield",
            paddingBottom: '0 !important',
        },
    }))

export const ContainerInputNumber = styled(Box, { label: "DrawerPartDetails-ContainerInputNumber" })(
    ({ theme }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: "100%",

       

        "input[type='number']": {
            border: '1px solid ' + StyleguideSavioColors.lightGrey,
            height: 33,
            boxSizing: 'border-box',
            borderLeft: 0,
            borderRight: 0,
            textAlign: 'center',
            fontSize: 14,
        },
        '> :nth-last-of-type(1)':{

            "@media print": {
                width: 'auto',
            },

        },

        '> :nth-last-of-type(2)': {
            "@media print": {
                marginLeft: 5,
            }
        },
        ".MuiInput-root": {
            boxShadow: 0,

            "&:before, &:after": {
                display: 'none',
            }
        }
    })
);

export const PopupDeleteText = styled(DialogContentText, { label: "DeleteRowComponent-PopupDeleteText" })(
    ({ theme }) => ({
        color: StyleguideSavioColors.text.black,
    }))

export const TitleDialog = styled("h2", { label: "TitleDialog" })(({ theme }) => ({
    color: 'inherit',
    marginTop: 0,
    textAlign: 'left',
    fontSize: 20,
    marginBottom: 6,
})
);

export const WarningBoxStyled = styled(Box, { label: "WarningBoxStyled" })(({ theme }) => ({
    display: 'flex',
    marginLeft: 8,
    width: 24,
})
);

export const useTableLayoutClasses = () => {
    const theme = useTheme();
    const classes = {
        tableContainer: {
            // height: 'calc(100vh - 150px)',
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "auto",
            paddingBottom: "40px",
        },

        table: {
            tableLayout: "fixed",
            "& th": {
                borderBottom: "2px solid #ececec",
                borderCollapse: "collapse",
                "&.openNextLevel, &.withreplacement, &.showBasket   ": {},
                "&.position": {
                    width: 25,
                    textAlign: "right",
                },
                "&.code": {
                    width: 65,
                },
                '&.mcc': {

                            width: 16,

                           
                        },
                        '&.codeDescription':{
                            width: 72,
                        }
            },

            "tbody td": {
                "&.openNextLevel, &.withreplacement, &.showBasket   ": {
                    textAlign: "center",
                    ">.MuiBox-root": {
                        ">.MuiBox-root": {
                            svg: {},
                        },
                    },

                    ">div": {
                        padding: "0 !important",
                        width: "100%",
                    },
                },
                "&.position": {
                    textAlign: "right",
                },
                "&.code": {
                    ".MuiTypography-root": {
                        width: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: 14,
                    },
                },
                "&.showBasket": {
                    svg: { fontSize: "23px !important" },
                },
                
                            '&.mcc': {

                               '> div':{
                                alignItems: 'center',
                                display: 'flex',
                               }
                               
                            },
            },
            "tbody tr": {
                "&.selected": {
                    backgroundColor: StyleguideSavioColors.mainBlue,

                    "*": { color: "#fff" },
                    "&:hover": {
                        backgroundColor: StyleguideSavioColors.mainBlue + "  !important",
                        //"*": { color: "#fff !important" },
                    },
                },
            },
        },
        columnDesc: {
            width: "calc(100% - 150px)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            align: "left",
            "> .MuiTypography-root": {
                color: StyleguideSavioColors.text.black,
            },
        },

        textColumn: {
            width: "90px",
            paddingLeft: "5px",

            "> .MuiTypography-root": {
                color: StyleguideSavioColors.text.black,
            },
        },

        shortTextColumn: {
            width: "30px",
            paddingLeft: "5px",
            backgroundColor: 'red',

            "> .MuiTypography-root": {
                color: StyleguideSavioColors.text.black,
            },
        },

        iconColumn: {
            width: "5px",
            paddingLeft: "0px",
        },

        columnImage: {
            width: "25px",
        },

        columnReplaced: {
            // width: "35px",
            svg: {
                color: theme.palette.primary.main,
            },
        },

        columnLogo: {
            width: "50px",
        },

        columnBasket: {
            color: theme.palette.primary.main,
            svg: {
                color: theme.palette.primary.main,
            },
        },

        columnFileName: {
            display: "flex",
            padding: "0px 5px 0px 0px !important",
            svg: {
                color: theme.palette.primary.main,
            },
        },

        columnDiscount: {
            width: 50,
            background: "#fff",
            //fontWeight: '800',
            borderRadius: '3px',
            border: '1px solid #ff7800',
        },

        headerColumn: {
            textTransform: "uppercase",
            color: StyleguideSavioColors.text.black,
            background: theme.palette.grey[100],
            fontWeight: StyleguideSavioFonts.bold,
        },

        bodyColumn: {
            textTransform: "uppercase",
            color: StyleguideSavioColors.text.black,
        },

        iconSize: {
            fontSize: 26 + "px !important",
            marginTop: "11px",
        },

        iconCell: {
            width: "100%",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },

        InputComponent: {
            // Per nascondere le frecce su Webkit (Chrome, Safari, Edge)
            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                {
                    appearance: "none",
                    margin: 0,
                },
            // Per nascondere le frecce su Firefox
            "& input[type=number]": {
                MozAppearance: "textfield",
            },
        },
        spanInside: {
            width: "100%",
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        machine: {
            color: theme.palette.primary.main,
            width: "fit-content",
            button: {
                "&:hover": {
                    color: "#fff",
                    backgroundColor: StyleguideSavioColors.blue,
                },
            },
        },
        notMachine: {
            color: StyleguideSavioColors.grey,
            button: {
                color: theme.palette.primary.main,
                "&:hover": {
                    color: "#fff",
                    backgroundColor: StyleguideSavioColors.blue,
                },
            },
        },

        qtyComponent: {
            width: 120,
            display: "flex",
        },

        hideOnPrint: {
            // display: 'inherit !important',
            "@media print": {
                display: "none !important",
            },
        },

        showOnPrint: {
            display: "none !important",

            "@media print": {
                display: "inline-flex !important",
            } as SxProps,
        },
        logoImg: {
            maxWidth: "150px",
        },
    };
    return classes;
};